/* eslint-disable no-loop-func */
import React, { useState } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery
} from '@material-ui/core'

import logoSvg from '../../../assets/img/logo.svg'

export default function CarRepairReport({ car, value }) {
  const [open, setOpen] = useState(false)

  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('xs'))

  if (value === null) {
    return null
  }

  const handleClose = () => {
    setOpen(false)
  }

  let totalExpenses = 0
  let partsExpenses = 0
  let laborExpenses = 0

  const technicalInspectionList = [
    'technicalInspectionBrakeSystem',
    'technicalInspectionCoolingSystem',
    'technicalInspectionEngine',
    'technicalInspectionHeating',
    'technicalInspectionPowerSupply',
    'technicalInspectionSafety',
    'technicalInspectionSteering',
    'technicalInspectionSuspension',
    'technicalInspectionTransmission',
    'technicalInspectionWheelDrive',
    'inspectionExternalPurch',
    'inspectionInternalPurch'
  ]

  for (let techInspectionItem of technicalInspectionList) {
    value[techInspectionItem] &&
      Object.keys(value[techInspectionItem]).forEach(function (key) {
        if (value[techInspectionItem][key].expensesParts !== undefined) {
          value[techInspectionItem][key].expensesParts.forEach(exp => {
            totalExpenses = totalExpenses + parseInt(exp)
            partsExpenses = partsExpenses + parseInt(exp)
          })
        }

        if (value[techInspectionItem][key].expensesLabor !== undefined) {
          value[techInspectionItem][key].expensesLabor.forEach(exp => {
            totalExpenses = totalExpenses + parseInt(exp)
            laborExpenses = laborExpenses + parseInt(exp)
          })
        }
      })
  }

  return (
    <>
      <Button
        color="primary"
        variant={'contained'}
        fullWidth
        size={'small'}
        onClick={() => setOpen(true)}
      >
        Акт осмотра авто
      </Button>

      <Dialog
        style={{ overflow: 'hidden' }}
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
      >
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginInline: '3em',
            marginBlockStart: '2em',
            flexDirection: isSmallScreen ? 'column' : 'row',
            gap: isSmallScreen ? '1em' : ''
          }}
        >
          <Box style={{ order: isSmallScreen ? 1000 : 0 }}>
            <Typography style={{ fontWeight: '900' }}>
              {car.marka.name} {car.model.name} {car.year}
            </Typography>

            <Typography>{car.vin}</Typography>
          </Box>

          <img src={logoSvg} height={50} />
        </Box>

        <Typography
          style={{
            color: '#333',
            fontWeight: '900',
            textAlign: 'center',
            fontSize: '22px',
            marginBlockStart: '2em'
          }}
        >
          АКТ ОСМОТРА АВТОМОБИЛЯ
        </Typography>

        <TableContainer
          style={{
            marginBlock: '1em'
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Повреждения</TableCell>
                <TableCell>Виды повреждений</TableCell>
                {!isSmallScreen && <TableCell>Комментарий</TableCell>}
              </TableRow>
            </TableHead>

            <TableBody>
              {technicalInspectionList
                .map(inspectionType =>
                  Object.keys(value[inspectionType] || {}).map(
                    (key, objIndex) => {
                      if (
                        ['OK', 'Не предусмотрено'].some(status =>
                          value[inspectionType][key].state.includes(status)
                        ) ||
                        [''].includes(value[inspectionType][key].name) ||
                        (inspectionType === 'inspectionExternalPurch' &&
                          ![
                            'longeronFrontLeft',
                            'longeronFrontRight',
                            'longeronRearLeft',
                            'longeronRearRight'
                          ].includes(key)) ||
                        (inspectionType === 'inspectionInternalPurch' &&
                          [
                            'addSeatsRow',
                            'armrests',
                            'carpetedFloor',
                            'doorCardFrontLeft',
                            'doorCardFrontRight',
                            'doorCardRearLeft',
                            'doorCardRearRight',
                            'luggageSpace',
                            'panel',
                            'rearSeats',
                            'roofCover',
                            'sealantRubbers',
                            'seatDriver',
                            'seatPassangerState',
                            'selectorTransmissionAndHolder',
                            'wheel'
                          ].includes(key))
                      ) {
                        return null
                      }

                      return (
                        value[inspectionType][key].repairType !== undefined &&
                        value[inspectionType][key].repairType.filter(
                          x => x !== ''
                        ).length !== 0 && (
                          <TableRow key={key + objIndex}>
                            <TableCell
                              style={{
                                fontWeight: '600',
                                fontSize: '14px'
                              }}
                            >
                              {value[inspectionType][key].name}{' '}
                              <span style={{ fontWeight: 400 }}>
                                {isSmallScreen &&
                                  value[inspectionType][key].comments &&
                                  `(Комментарий: ${value[inspectionType][key].comments})`}
                              </span>
                            </TableCell>

                            <TableCell style={{ fontSize: '14px' }}>
                              {value[inspectionType][key].state
                                .filter(
                                  x =>
                                    x !== '' && x !== 'Заводской окрас детали'
                                )
                                .map(state => state)
                                .join(', ')}
                            </TableCell>

                            {!isSmallScreen && (
                              <TableCell
                                style={{
                                  fontSize: '14px'
                                }}
                              >
                                {value[inspectionType][key].comments || '-'}
                              </TableCell>
                            )}
                          </TableRow>
                        )
                      )
                    }
                  )
                )
                .filter(item => !!item)}
            </TableBody>
          </Table>
        </TableContainer>

        {car.branch.code === 'ALA_BESAGASH' && (
          <Typography
            style={{
              fontSize: 14,
              marginBlock: '1.5em',
              marginInline: 'auto'
            }}
          >
            ASTER АЛМАТЫ (БЕСАГАШ), +7 (727) 341 08 88
          </Typography>
        )}

        {car.branch.code === 'ASTANA' && (
          <Typography
            style={{
              fontSize: 14,
              marginBlock: '1.5em',
              marginInline: 'auto'
            }}
          >
            ASTER АСТАНА +7 (708) 941 08 99
          </Typography>
        )}

        {car.branch.code === 'SHYMKENT' && (
          <Typography
            style={{
              fontSize: 14,
              marginBlock: '1.5em',
              marginInline: 'auto'
            }}
          >
            ASTER ШЫМКЕНТ +7 708 941 08 88
          </Typography>
        )}

        <DialogActions>
          <Button
            color="primary"
            variant="contained"
            onClick={() => setOpen(false)}
          >
            Закрыть
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
